import type { LifeAnniversaryDTO, LifeMinDTO } from '../schedule/schedule'
import type { UserMinDTO } from '../user/users'
import {
  NOTIFICATION_BASE,
  NOTIFICATION_COUNT,
  NOTIFICATION_LIST,
  NOTIFICATION_SET_ALL_READ,
  NOTIFICATION_SET_LIST_READ,
  NOTIFICATION_SET_READ,
  netClient,
  type CommonResponse
} from '@/apis/api'
import { defineStore } from 'pinia'
import { handleErr } from '../exception/handler'
import { CODE_OK } from '@/apis/code'
import { ElMessage } from 'element-plus'
import { renderMessage } from '@/utils/util'
import type { Ref } from 'vue'
import { useLocalStorage } from '@vueuse/core'

export interface ListNotificationResponse {
  page: number
  pageSize: number
  total: number
  totalPages: number
  items: Array<NotificationDTO>
}

export type NotificationType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10

export interface NotificationDTO {
  id: string
  type: NotificationType
  title: string
  content: string
  recipientId: string
  payload: NotificationPayload
  isRead: boolean
  wechatNotified: boolean
  smsNotified: boolean
  emailNotified: boolean
  appPushed: boolean
  clientType: number
  triggeredBy: string
  life: LifeMinDTO
  who: UserMinDTO
  createdAt: number
}

export interface NotificationPayload {
  type: number
}

export interface CommonPayload extends NotificationPayload {
  urlName: string
  url: string
}

export interface MemorizePayload extends NotificationPayload {
  serviceId: string
  lifeId: string
  creatorId: string
  createdAt: number
  id: string
  fileIds: Array<String>
  opsType: number
  memorialType: number
}

export interface SchedulePayload extends NotificationPayload {
  lifeId: string
  lifeAnniversaryId: string
  daysGap: number
  anniversaryTime: number
  calType?: number
}

export interface UpgradePayload extends NotificationPayload {
  version: string
  versionName: string
  updateMsg: string
  url: string
}

export interface WreathPayload extends NotificationPayload {
  //4
  obituaryId: string
  wreathSentId: string
}

// couplet
export interface CoupletPayload extends NotificationPayload {
  //5
  obituaryId: string
  coupletSentId: string
}

// thanks
export interface ObituaryThanksPayload extends NotificationPayload {
  //6
  obituaryId: string
  thanksId: string
  wreathSentId: string
  coupletSentId: string
}

export interface OfferingPayload extends NotificationPayload {
  //7
  altarId: string
  offeringId: number
  offererId: string
}

export interface CommentThanksPayload extends NotificationPayload {
  //8
  type: number
  serviceId: string
  messageId: string
  thanksId: string
  createdAt: number
  id: string
}

export function listNotifications(last: string | null, pageSize: number) {
  return netClient.request<CommonResponse<ListNotificationResponse>>(
    NOTIFICATION_LIST,
    'get',
    last
      ? {
          last: last,
          pageSize: pageSize
        }
      : {
          pageSize: pageSize
        }
  )
}

export function setNotificationRead(notificationId: string) {
  return netClient.request<CommonResponse<any>>(NOTIFICATION_SET_READ, 'post', { notificationId: notificationId })
}

export function setNotificationListRead(notificationIds: Array<string>) {
  return netClient.request<CommonResponse<any>>(NOTIFICATION_SET_LIST_READ, 'post', {
    notificationIds: notificationIds
  })
}

export function setNotificationAllRead() {
  return netClient.request<CommonResponse<any>>(NOTIFICATION_SET_ALL_READ, 'post', {})
}

export function deleteNotification(notificationId: string) {
  return netClient.request<CommonResponse<any>>(NOTIFICATION_BASE + '/' + notificationId, 'delete', {})
}

export interface UnreadCountResponse {
  count: number
}

export const useUnreadCount = defineStore('unreadCount', () => {
  // 使用 localStorage 持久化 count
  const count = useLocalStorage('notification/unreadCount', 0, {
    serializer: {
      read: (v) => Number(v) || 0, // 确保数值类型
      write: (v) => v.toString()
    }
  })

  // 保持原有方法不变
  const update = (newCount: number) => {
    count.value = newCount
  }

  return { count, update }
})

export function unreadNotificationCount() {
  return netClient.request<CommonResponse<UnreadCountResponse>>(NOTIFICATION_COUNT, 'get', {})
}

export async function retrieveNotificationCount() {
  const unreadStore = useUnreadCount()
  const { data, error, statusCode } = await unreadNotificationCount()
  if (error.value) {
    // handleErr(data, error, statusCode)
  } else {
    const resData = data as Ref<CommonResponse<UnreadCountResponse>>
    if (resData.value.code === CODE_OK) {
      // success
      // console.log('get life list success', resData.value.data)
      const res: UnreadCountResponse = resData.value.data
      unreadStore.update(res.count)
    } else {
      // ElMessage({
      //   message: renderMessage(resData.value.message),
      //   type: 'warning'
      // })
    }
  }
}

export function getUnreadCountStore() {
  return useUnreadCount()
}
